import { Component, DestroyRef, inject, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GateConfigElement } from '../../../../interfaces/company';
import { DisclaimerTypes } from '../../../../interfaces/disclaimertypes';
import { GenericStreamListForUserSelection, StreamOrderItem } from '../../../../interfaces/responsedata.ts/generic-streams';
import { UserGateProgressElement, UserGateProgressStreamElement } from '../../../../interfaces/userdata';
import { AppdataService } from '../../../../service/appdata.service';
import { CategoryService } from '../../../../service/category.service';

interface DataForStreamSelect {
    userCredits: number;
    streamList: GenericStreamListForUserSelection[];
    userGateConfig: GateConfigElement[] | undefined;
    userGateProgress: UserGateProgressElement[] | undefined;
}

@Component({
    selector: 'app-select-stream',
    standalone: false,
    templateUrl: './select-stream.component.html',
    styleUrl: './select-stream.component.scss'
})
export class SelectStreamComponent implements OnInit {
    @ViewChild('searchinput') searchInput: any;
    // injections
    readonly dialogRef = inject(MatDialogRef<SelectStreamComponent>);
    public data: DataForStreamSelect = inject(MAT_DIALOG_DATA);
    private destroyRef = inject(DestroyRef);
    protected dataService = inject(AppdataService);
    protected catService = inject(CategoryService);

    // Variables
    activeSearch: boolean = false;
    searchValue: string = "";
    showInfo: boolean = false;
    showBackBtn: boolean = false;
    xcoord: number = 0;
    ycoord: number = 0;
    infoText: string = "";
    disaclaimerType = DisclaimerTypes.PAY_FOR_CHOISE;

    streamSelectList: GenericStreamListForUserSelection[] = [];
    selectedStreamId: string = "";

    mainCategories: any[] = [];
    contentToShow: any[] = [];
    packageName: string = "";
    selectedGate: UserGateProgressElement | undefined;


    async ngOnInit(): Promise<void> {
        this.searchValue = "";
        this.activeSearch = false;
        const uniqueById = new Map<string, GenericStreamListForUserSelection>();
        for (const stream of this.data.streamList) {
            if (!stream?.id || !stream?.name) {
                continue;
            }
            const streamName = stream.name.toLowerCase();
            if (streamName.includes('test') || streamName.includes('dummy')) {
                continue;
            }
            if (!uniqueById.has(stream.id)) {
                uniqueById.set(stream.id, stream);
            }
        }

        this.streamSelectList = Array.from(uniqueById.values());

        const hasChargeableStreams = this.streamSelectList.some((stream) => (stream.credits || 0) > 0);
        this.disaclaimerType = hasChargeableStreams
            ? DisclaimerTypes.PAY_FOR_CHOISE
            : DisclaimerTypes.EXTERNAL_RISK;

        this.dialogRef.keydownEvents()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: (event) => {
                    if (event.key === 'Enter' && this.selectedStreamId !== "") {
                        event.preventDefault();
                        this.dialogRef.close(this.selectedStreamId);
                    }
                    takeUntilDestroyed();
                },
            });



        const structData: StreamOrderItem[] | false = await this.dataService.loadStructuredCategoriesAndStreams();
        if (structData === false) {
            return;
        }


        this.dataService.streamCategories.subscribe((categories: any) => {
            this.mainCategories = categories.filter((category: any) => category.parentId === null);


            this.mainCategories.forEach(category => {
                category.active = false;
                category.children = categories.filter((child: any) => child.parentId === category.id);
                category.children.forEach((child: any) => {
                    child.showType = "PACKAGE";
                    child.streams = structData.filter(stream => stream.categoryId === child.id);
                    child.streams.forEach((stream: any) => {
                        stream.showType = "STREAM";
                        stream.data = this.streamSelectList.find(s => s.id === stream.streamId);
                    });
                    // Loop through streams, if data is undefined delete stream
                    child.streams = child.streams.filter((stream: any) => stream.data !== undefined);
                });
            });
            this.mainCategories[0].active = true;
            this.contentToShow = this.mainCategories[0].children;
            this.selectedStreamId = "";
        });
        console.log(this.mainCategories);
    }

    setVerticalToActive(categoryId: string) {
        this.mainCategories.forEach(category => {
            if (category.id === categoryId) {
                category.active = true;
                this.contentToShow = category.children;
            } else {
                category.active = false;
            }
        });
        this.selectedStreamId = "";
        this.packageName = "";
        this.showBackBtn = false;
    }

    chooseBack() {
        const currentCat = this.mainCategories.find(category => category.active);
        this.setVerticalToActive(currentCat.id);
        this.selectedGate = undefined;
    }

    chooseGate(element: UserGateProgressElement) {
        this.selectedGate = element;
        this.contentToShow = [];
        element.streamIdList.forEach((stream: UserGateProgressStreamElement) => {
            // console.log(stream)
            const streamData = this.streamSelectList.find(s => s.id === stream.streamId);
            if (streamData) {
                this.contentToShow.push(streamData)
            }
        });
        this.showBackBtn = true;
    }

    choosePackage(element: any) {
        console.log(element)
        this.contentToShow = [];
        this.packageName = element.name;
        element.streams.forEach((stream: any) => {
            // console.log(stream)
            if (stream.data) {
                stream.data.showType = "STREAM";
                this.contentToShow.push(stream.data)
            }
        });
        this.selectedStreamId = "";
        this.showBackBtn = true;
    }


    activateSearch() {
        this.activeSearch = true;
        setTimeout(() => {
            this.searchInput.focus();
        }, 100);
    }
    deactrivateSearch() {
        this.activeSearch = false;
        this.searchValue = "";
        this.searchStream();
    }
    searchStream() {
        if (this.searchValue === "") {
            this.streamSelectList = [...this.data.streamList];
            return;
        }

        this.streamSelectList = this.data.streamList.filter(stream =>
            stream.name.toLowerCase().includes(this.searchValue.toLowerCase())
            // ||
            // stream.description.toLowerCase().includes(this.searchValue.toLowerCase())
        );

    }
    startStream() {
        this.dialogRef.close(this.selectedStreamId)
    }

    close() {
        this.dialogRef.close();
    }
    openInfo(text: string, ev: any) {
        this.xcoord = ev.clientX + 20;
        this.ycoord = ev.clientY;
        this.infoText = text;
        this.showInfo = true;

    }
    closeInfo() {
        this.showInfo = false;
        this.xcoord = 0;
        this.ycoord = 0;
        this.infoText = "";
    }
}
